import type { GoalDataYtd } from 'donor-elf-web/models/goal';
import DashboardYtdController from './ytd';
import moment from 'moment';

export default class DashboardYlController extends DashboardYtdController {
  get goalDataYoungLife() {
    return (this.goalData as GoalDataYtd).young_life;
  }

  get monthlyPledgesStartDate() {
    return moment().startOf('month').format('YYYY-MM-DD');
  }

  get monthlyPledgesEndDate() {
    return moment().endOf('month').format('YYYY-MM-DD');
  }
}
